import { HttpMethods, makeRequest } from '../helpers/http.helper';
import type { OpsRouteRun, TruckTrackingItem } from '../types/fleet.type';

interface Envelope<T> {
  result?: T;
}

/**
 * Latest reported position per truck of a Waste Mover organization
 * (`truck.list`). The API keeps only the last position — no history.
 */
export const getTruckTracking = async (organizationId: string): Promise<TruckTrackingItem[]> => {
  const res = (await makeRequest({
    url: '/truck/tracking',
    method: HttpMethods.GET,
    params: { organization_id: organizationId },
  })) as Envelope<TruckTrackingItem[]>;
  return Array.isArray(res?.result) ? res.result : [];
};

/** Route runs of one day with stops and TomTom-planned geometry (`route_run.read`). */
export const listRouteRunsForDay = async (organizationId: string, runDate: string): Promise<OpsRouteRun[]> => {
  const res = (await makeRequest({
    url: '/ops/route-runs',
    method: HttpMethods.GET,
    params: { organization_id: organizationId, run_date: runDate },
  })) as Envelope<{ runs?: OpsRouteRun[] }>;
  return Array.isArray(res?.result?.runs) ? res.result.runs : [];
};
